import withViewEvent from '../modules/common/utils/tracking/withViewEvent';
import { K_AMPLITUDE_EVENT_VIEW_SIGN_IN_PAGE } from '../modules/common/libs/amplitude/events';
import SigninPage from '../modules/user/signin/pages/SigninPage';
import withGuessAuth from '../modules/user/utils/guard/withGuessAuth';

export default withGuessAuth(withViewEvent(SigninPage, K_AMPLITUDE_EVENT_VIEW_SIGN_IN_PAGE));
